import { Fragment, useEffect, useState } from "react";
import { Form, Button, FormLabel, FormGroup, FormControl, Row, Col, Table } from "react-bootstrap";
import { Formik, FieldArray } from "formik";
import DatePicker from "react-datepicker";
import * as yup from "yup";
import { useSelector} from "react-redux";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import Select from 'react-select'
import { useLazyGetCRMCustomerDetailsListQuery } from "app/redux/Customer/customerApi";
import {ArrowLeftCircle, PersonAdd, Trash} from "react-bootstrap-icons";
import AddCustomerModal from "app/views/dashboard/modal/AddCustomerModal";
import { format } from "date-fns";
import {useLazyAddRentersQuery, useLazyUpdateRentersQuery, useLazyGetRenterTypesQuery, useLazyDeleteRentersQuery} from "app/redux/ownership/ownershipApi";
import { toast } from "react-toastify";
import swal from "sweetalert2";

export default function AddEditOwnerships({
    show,
    handleFormRenterSubmit,
    toggleRenterEditorDialog,
    // ContractId,
    // renterId,
    // screenType,
    // OwnershipDate,
    // OwnerShipEndDate,
    // OriginalRenterStartDate,
    // OriginalRenterEndDate,
    renterdetails,
    initialValues = {}
  }) {

    const [AddRenters] = useLazyAddRentersQuery();
    const [UpdateRenters] = useLazyUpdateRentersQuery();
    const [getRenterTypes] = useLazyGetRenterTypesQuery();
    const [deleteRenters] = useLazyDeleteRentersQuery();

    const [addCustomerModalState, setAddCustomerModalState] = useState({
        addCustomerdialogValues: null,
        addCustomershowEditorDialog: false
    });

    const [isFormSubmit, setFormSubmit] = useState(false);
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [customerFullDetailList, setCustomerFullDetailListState] = useState([]);
    const [renterTypeList, setRenterTypeList] = useState([]);
    const [renterTypeId, setRenterTypeId] = useState(0);
    let [customerDetailList, setCustomerDetailListState] = useState([]);
    let [renterStartDateState, setRenterStartDateState] = useState('');
    let [renterEndDateState, setRenterEndDateState] = useState('');

    let [ContractId, setContractIdState] = useState('');
    let [ContractRowId, setContractRowIdState] = useState(0);
    let [renterId, setRenterIdState] = useState(0);
    let [screenType, setScreenTypeState] = useState('');
    let [OwnershipDate, setOwnershipDateState] = useState('');
    let [OwnerShipEndDate, setOwnerShipEndDateState] = useState('');
    let [OriginalRenterStartDate, setOriginalRenterStartDateState] = useState('');
    let [OriginalRenterEndDate, setOriginalRenterEndDateState] = useState('');
    let [ContractRenterType, setContractRenterTypeState] = useState(1);
    let [DefaultcntractRenterType, setDefaultcntractRenterType] = useState({label:'Bruksoverlating', value: 1});

    const [state, setState] = useState({
      reterStartDate: "",
      reterList: []
    });
    const { selectedCompanyId } = useSelector((state) => state.company);
    const [getCRMCustomerDetailsList] = useLazyGetCRMCustomerDetailsListQuery();

    const addCustomerToggleEditorDialog = (arg) => {
        if (arg && arg.toString()) {
            setAddCustomerModalState((prevState) => ({ ...prevState, addCustomershowEditorDialog: true, addCustomerdialogValues: null }));
        } else {
            setAddCustomerModalState((prevState) => ({
            ...prevState,
            addCustomerdialogValues: null,
            addCustomershowEditorDialog: !addCustomerModalState.addCustomershowEditorDialog
            }));
        }
    };

    useEffect(() => {
      fetchRenterTypeList();
      setPreValues(initialValues);
      fetchCRMCustomerDetailsList(0, initialValues.renterScreenType);
    }, []);

    const setPreValues = (preValues) => {
      if(preValues){
        setContractIdState(preValues.ContractId);
        setRenterIdState(preValues.renterId);
        setScreenTypeState(preValues.renterScreenType);
        setOwnershipDateState(preValues.OwnershipDate);
        setOwnerShipEndDateState(preValues.OwnerShipEndDate);
        setOriginalRenterStartDateState(preValues.OriginalRenterStartDate);
        setOriginalRenterEndDateState(preValues.OriginalRenterEndDate);
        setRenterStartDateState(preValues.OriginalRenterStartDate);
        setRenterEndDateState(preValues.OriginalRenterEndDate);
        setContractRenterTypeState(preValues.contractRenterType);
        if(renterTypeList && renterTypeList.length > 0){
          const existingRenterType = renterTypeList.filter(a => a.Id == preValues.contractRenterType);
          if(existingRenterType && existingRenterType.length > 0){
            setDefaultcntractRenterType({label:existingRenterType[0].label, value: existingRenterType[0].value});
          }
        }
        else{
          if(preValues.contractRenterType == '1'){
            setDefaultcntractRenterType({label:'Bruksoverlating', value: 1});
          }
          else if(preValues.contractRenterType == '2'){
            setDefaultcntractRenterType({label:'Bruksoverlating til familie', value: 2});
          }
        }
      }
    }

    const setExistingOwnerData = (customerData) => {
      // if(OriginalRenterStartDate){

      // }
      // let renterStartDate = format(OriginalRenterStartDate, "yyyy-MM-dd");
      // setRenterStartDateState(renterStartDate);
      // if(OriginalRenterEndDate){
      //   let tempRenterEndDate = format(OriginalRenterEndDate, "yyyy-MM-dd");
      //   setRenterEndDateState(tempRenterEndDate);
      // }
      
      if(renterdetails && renterdetails.length > 0){
        renterdetails.forEach((item, indx) => {
          if(item.ContractRenterID){
            setCustomerInOwnership(item.ContractRenterID, customerData, "Edit", item.InvoiceRecipient);
          }
        });
      }

      if(renterdetails && renterdetails.ContractRenterID){
        setCustomerInOwnership(renterdetails.ContractRenterID, customerData, "Edit", renterdetails.InvoiceRecipient);
      }
     
    }

    const fetchRenterTypeList = async() => {
        showLoader();
        getRenterTypes().then((result) => {
            hideLoader();
            if (result.isSuccess) {
                console.log('fetchRenterTypeList - ', result);
              let tempdata = result.data.data;
              let renterTypeData = tempdata.map((e) => ({
                ...e,
                value: e.Id,
                label: e.NorName
              }));
              setRenterTypeList(renterTypeData);
              setRenterTypeId(renterTypeData[0].value);
            }
          });
    }

    const fetchCRMCustomerDetailsList = async(custId, type="") => {
        showLoader();
        getCRMCustomerDetailsList({
            CompanyId: selectedCompanyId,
            CustomerType: 3,
            IsArchive: false,
            ContractTypeID: 0
          }).then((result) => {
            hideLoader();
            if (result.isSuccess) {
              let tempdata = result.data.data;
              let customerData = tempdata.map((e) => ({
                ...e,
                value: e.CustomerId,
                label: e.ContactName
              }));
              //console.log('customerdata -- ', customerData);
              if(custId && custId !== 0){
                setCustomerInOwnership(custId, customerData, "New");
              }
              setCustomerFullDetailListState(customerData);
              setCustomerDetailListState(customerData);
              if(type === "Edit"){
                setExistingOwnerData(customerData);
              }
            }
          });
    }

    const setCustomerInOwnership = (custId, customerData, type, IsInvoiceRecipient=false) => {
        if(custId && custId !== 0){
            let selectedCustDetail = customerData.filter(a => a.CustomerId === custId);
            if(selectedCustDetail && selectedCustDetail.length > 0){
                let ownerdet = state.reterList;
                let ownerdetLength = 0;
                if(ownerdet && ownerdet.length > 0){
                  ownerdetLength = ownerdet.length;
                  const chkAlreadyExists = ownerdet.filter(a => a.CustomerID === custId);
                  if(chkAlreadyExists && chkAlreadyExists.length > 0){
                    return;
                  }
                }
                let tempval = {};
                tempval.CustomerID = selectedCustDetail[0].CustomerId
                tempval.Name =selectedCustDetail[0].CustomerNickName;
                tempval.Email = selectedCustDetail[0].PrimaryEmail;
                tempval.Phone = selectedCustDetail[0].PrimaryPhone;
                tempval.IsPrivateCustomer = true;
                if(type === "Edit"){
                  tempval.IsInvoiced = IsInvoiceRecipient;
                }
                else{
                  tempval.IsInvoiced = ownerdetLength === 0 ? true : false;
                }

                ownerdet.push(tempval);
                setState({
                    reterList: ownerdet
                });
                
            }
            
         }
    }

    const handleSubmit = async (values, { setSubmitting }) => {
        showLoader();  
        let isFormValid = true;
        let formInvalidMesaage = "";
        setFormSubmit(true);
        let renterDetail = state.reterList;

        if(renterStartDateState === ""){
            isFormValid = false;
            formInvalidMesaage = "start date cannot be blank";
        }
       
        if(isFormValid){
          
            const ContractTypeId = 0;
            const OwnerShipDate = format(OwnershipDate, "yyyy-MM-dd");
            let OwnerShipEndDate = "";
            if(OwnerShipEndDate !== "" ){
                    OwnerShipEndDate = format(OwnerShipEndDate, "yyyy-MM-dd");
            }
            const RenterStartDate = format(renterStartDateState, "yyyy-MM-dd");
            let RenterEndDate = "";
            if(renterEndDateState !== "" ){
                RenterEndDate = format(renterEndDateState, "yyyy-MM-dd");
            }
            let originalRenterStartDate = "";
            if(OriginalRenterStartDate !== ""){
                originalRenterStartDate = format(OriginalRenterStartDate, "yyyy-MM-dd");
            }

            let originalRenterEndDate = "";
            if(OriginalRenterEndDate !== ""){
                originalRenterEndDate = format(OriginalRenterEndDate, "yyyy-MM-dd");
            }

            const MoveInDate = RenterStartDate;
            const Price = 0;
            const Notes = "";
            const AddedByPersonID = localStorage.getItem('loginUserPersonId');
            const AddedByUserRoleID = 1;
            const AddedByCompanyId = localStorage.getItem('CompanyId');
            const NoOfRenters = renterDetail;

            const RenterTypeId = 1;
            const contractRenterType = 1;
            const source = "KeyFree";

            let newFormData = {};
            newFormData.ContractTypeId = ContractTypeId;
            newFormData.ContractId = ContractId;
            newFormData.OwnerShipDate = OwnerShipDate;
            newFormData.OwnerShipEndDate = OwnerShipEndDate;
            newFormData.RenterStartDate = RenterStartDate;
            newFormData.OriginalRenterStartDate = originalRenterStartDate;
            newFormData.RenterEndDate = RenterEndDate;
            newFormData.MoveInDate = MoveInDate;
            newFormData.Price = Price;
            newFormData.Notes = Notes;
            newFormData.AddedByPersonID = AddedByPersonID;
            newFormData.AddedByUserRoleID = AddedByUserRoleID;
            newFormData.AddedByCompanyId = AddedByCompanyId;
            newFormData.RenterTypeId = RenterTypeId;
            newFormData.contractRenterType = contractRenterType;
            newFormData.source = source;
            
            let NoOfReterArray = [];
            NoOfRenters.forEach((item, indx) => {
              let owner = {};
              owner.ContractRenterID = item.CustomerID;
              owner.ContractRenterName = item.Name;
              owner.ContractRenterRowID = 0;
              owner.InvoiceRecipient = item.IsInvoiced;
              NoOfReterArray.push(owner);
            });
            newFormData.NoOfRenters = NoOfReterArray;

            if(screenType === "Edit"){
                await UpdateRenters(newFormData).then((result) => {
                hideLoader();
                if(result.data.isSuccess){
                    toast.success("Renter updated successfully", { autoClose: 2000 });
                    handleFormRenterSubmit();
                    toggleRenterEditorDialog();
                }
                else{
                    toast.error(result.data.message, { autoClose: 2000 });
                }
                }, error => {
                hideLoader();
                toast.error(error);
                });
            }
            else{
                await AddRenters(newFormData).then((result) => {
                hideLoader();
                if(result.data.isSuccess){
                    toast.success("Renter created successfully", { autoClose: 2000 });
                    handleFormRenterSubmit();
                    toggleRenterEditorDialog();
                }
                else{
                    toast.error(result.data.message, { autoClose: 2000 });
                }
                }, error => {
                hideLoader();
                toast.error(error);
                });
            }
          
          
        }
        else{
          hideLoader();
          if(!isFormValid){
            toast.error(formInvalidMesaage, { autoClose: 2000 });
          }
        }


    };

    const handleDeleteCustomer = async (itemIndx, customerId) => {
      let ownerdet = state.reterList;
      ownerdet = ownerdet.filter(a => a.CustomerID !== customerId);
      setState({
        reterList: ownerdet
      });
    };

    const onChange = (event) => {
        if(event){
           customerDetailList = customerDetailList.filter(a => a.CustomerId !== event.CustomerId);
           setCustomerDetailListState(customerDetailList);
           let ownerdet = state.reterList;
           let ownerdetLength = 0;
           if(ownerdet && ownerdet.length > 0){
             ownerdetLength = ownerdet.length;
           }
           let tempval = {};
           tempval.CustomerID = event.CustomerId
           tempval.Name =event.CustomerNickName;
           tempval.Email = event.PrimaryEmail;
           tempval.Phone = event.PrimaryPhone;
           tempval.IsInvoiced = ownerdetLength === 0 ? true : false;
           ownerdet.push(tempval);
           setState({
             reterList: ownerdet
           });
        }
       };

    const addCustomerHandleFormSubmit = async (values) => {
        fetchCRMCustomerDetailsList(values);
        addCustomerToggleEditorDialog(false);
    };

    const handleDeleteRenter = async () => {

      const options = {
        title: "Slett",
        text: "Er du sikker på å slette?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#fff !important",
        confirmButtonText: "Ja, slett den!",
        cancelButtonText: "Nei"
      };
  
      try {
        const { isConfirmed } = await swal.fire(options);
        if (!isConfirmed)
        {
          return;
        } 
        else{
          showLoader();
     
          let renterRowId = initialValues.renterId;
          let obj= {};
          obj.ContractID = ContractId;
          obj.ContractRentersID = renterRowId;
          await deleteRenters(obj).then((result) => {
            hideLoader()
            if(result.isSuccess){
              handleFormRenterSubmit();
              toggleRenterEditorDialog();
            }
          });
      
           hideLoader();
         
        }
      } catch (error) {}

      showLoader();
      
  
       hideLoader();
    }
    

  let { addCustomerdialogValues, addCustomershowEditorDialog } = addCustomerModalState;
  return (
    <div className="invoice-viewer py-3">
      <Formik
        initialValues={state}
        onSubmit={handleSubmit}
        // validationSchema={ownershipValidationSchema}
        enableReinitialize={true}>
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <Fragment>
              <Form onSubmit={handleSubmit} className="px-3">
                <div className="viewer_actions d-flex align-items-center justify-content-end gap-2 mb-4">
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => toggleRenterEditorDialog(false)}>
                   <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                    Tilbake
                  </Button>
                  <Button type="submit" variant="primary">
                    Lagre
                  </Button>
                  {
                    screenType === 'Edit' ? 
                    <Button className="ml-2" variant="secondary" onClick={() => handleDeleteRenter()} >
                      <Trash className={'me-2'} size={17}></Trash>
                      Delete
                    </Button>
                    : ""
                  }
                  
                </div>

                <Row className="justify-content-between">
                  <Col md={6} sm={7}>
                    <h4 className="fw-bold">
                        {screenType === "Edit" ? "Redigere" : "Legge til"} bruksoverlating
                    </h4>
                  </Col>
                </Row>
                <Row>
                    <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
                      <FormLabel>Start dato</FormLabel>
                      <DatePicker
                        className="form-control mb-1 w-100"
                        placeholder="Startdato(DD.MM.YYYY)"
                        dateFormat="dd.MM.yyyy"
                        selected={renterStartDateState ? new Date(renterStartDateState) :''}
                        onChange={(date) => {setFieldValue({ reterStartDate: date }); setRenterStartDateState(date);}}
                        onBlur={handleBlur}
                      />
                       {isFormSubmit && renterStartDateState === "" && (
                          <><small className="text-danger">Startdato kreves</small></>
                       )}

                    </FormGroup>
                    <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
                      <FormLabel>Slutt dato</FormLabel>
                      <DatePicker
                        className="form-control mb-1 w-100"
                        placeholder="Sluttdato(DD.MM.YYYY)"
                        dateFormat="dd.MM.yyyy"
                        selected={renterEndDateState ? new Date(renterEndDateState) :''}
                        onChange={(date) => {setFieldValue({ renterEndDateState: date }); setRenterEndDateState(date);}}
                        onBlur={handleBlur}
                      />
                       {/* {isFormSubmit && renterEndDateState === "" && (
                          <><small className="text-danger">Sluttdato kreves</small></>
                       )} */}

                    </FormGroup>
                    <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
                        <FormLabel>Type</FormLabel>
                        <Select
                            style={{width:"10px"}}
                            aria-labelledby="aria-label"
                            inputId="aria-example-input"
                            name="aria-live-color"
                            defaultValue={DefaultcntractRenterType}
                            //value={ContractRenterType}
                            onChange={(e) => 
                                {
                                    setRenterTypeId(e.value)

                                }}
                            options={renterTypeList}
                        />
                        {isFormSubmit && renterTypeId === 0 && (
                          <><br/> <small className="text-danger">Velg type</small></>
                       )}
                    </FormGroup> 
                </Row>

                <div className="mt-3 mb-4 border-top" />

                <Row>
                  <FieldArray >
                    {() => (
                      <Col xs={12}>
                        <Table responsive hover className="mb-3">
                          <thead className="bg-gray-300">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Navn</th>
                              <th scope="col">E-post</th>
                              <th scope="col">Telefon</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.reterList.map((item, ind) => (
                              <tr key={ind}>
                                <th className="text-middle" scope="row">
                                  {ind + 1}
                                </th>
                                <td>
                                  <FormControl
                                    value={values.reterList[ind].Name}
                                    name={`reterList[${ind}].Name`}
                                    type="text"
                                    placeholder="Navn"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    
                                  />
                                </td>
                                <td>
                                  <FormControl
                                    value={values.reterList[ind].Email}
                                    name={`reterList[${ind}].Email`}
                                    type="text"
                                    placeholder="e-post"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </td>
                                <td>
                                  <FormControl
                                    value={values.reterList[ind].Phone}
                                    name={`reterList[${ind}].Phone`}
                                    type="text"
                                    placeholder="telefon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteCustomer(ind, item.CustomerID)}
                                    className="btn btn-outline-secondary float-right">
                                    Slett
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        {/* {isFormSubmit && values.reterList.length === 0 &&
                          <small className="text-danger">Minimum 1 vare kreves</small>
                        } */}

                        

                        <Row className="mt-2">
                            <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
                                <Button variant="primary" onClick={addCustomerToggleEditorDialog}>
                                    <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                      Legg til ny eier
                                </Button>
                            </FormGroup> 
                            <FormGroup as={Col} xs={3} className="d-flex flex-column"> 
                                <Select
                                    style={{width:"10px"}}
                                    placeholder={"Velg eksisterende kunde"}
                                    aria-labelledby="aria-label"
                                    inputId="aria-example-input"
                                    name="aria-live-color"
                                    onChange={onChange}
                                    options={customerDetailList}
                                />
                            </FormGroup> 
                        </Row>
                        
                      </Col>
                    )}
                  </FieldArray>
                </Row>
              </Form>
              <AddCustomerModal
                show={addCustomershowEditorDialog}
                initialValues={addCustomerdialogValues}
                handleFormSubmit={addCustomerHandleFormSubmit}
                toggleEditorDialog={addCustomerToggleEditorDialog}
              />
              {loader}
            </Fragment>
          );
        }}
      </Formik>
    </div>
  );
}

